import React from 'react';
import { Trans } from '@lingui/macro';
import { useNavigation } from '@react-navigation/native';

import { Profile } from '@src/types';

import { EditButton } from './styled';
import { ScreenNavigationProp } from './types';

type Props = {
  profile: Profile;
};

const EditProfileButton: React.FC<Props> = ({ profile }) => {
  const { id } = profile;

  const navigation = useNavigation<ScreenNavigationProp>();

  const handleEditProfile = React.useCallback(
    () => navigation.push('ProfileEdit', { id }),
    [id, navigation]
  );

  return (
    <EditButton onPress={handleEditProfile}>
      <Trans>Edit Profile</Trans>
    </EditButton>
  );
};

export default EditProfileButton;
